import { Link } from "react-router-dom";
import { authService } from "../../../services/auth/authService";
import SxForm from "../../../forms/SxForm";
import { object, string } from "yup";
import SxField from "../../../forms/fields/SxField";
import SubmitButton from "../../../components/SubmitButton";
import { userService } from "../../../services/user/userService";
import { t } from "i18next";
import { useState } from "react";
import Dialog from "../../../components/Dialog";

function LoginForm({
  profileShareUid,
  premiumSponsorshipToken,
  premiumSponsorshipEmail,
}: {
  profileShareUid?: string;
  premiumSponsorshipToken?: string;
  premiumSponsorshipEmail?: string;
}) {
  const auth = authService();
  const { getLoggedUserHomeUrl } = userService();
  const [showUnvalidatedEmailPopup, setShowUnvalidatedEmailPopup] =
    useState(false);

  return (
    <>
      <SxForm
        initialValues={{
          // prefilled with the sponsored address, which is the only one the
          // invitation can be accepted on
          email: premiumSponsorshipEmail ?? "",
          password: "",
        }}
        onSubmit={(loginData) => {
          return auth
            .login({ ...loginData, sponsorshipToken: premiumSponsorshipToken })
            .then(
              async () => {
                // NOTE: Used to reload completely the html HEADERS when on login
                // So that we can load stripe without problem
                // SOURCE: https://github.com/stripe/stripe-js/issues/417
                if (profileShareUid) {
                  window.location.href = `/profile-share/${profileShareUid}`;
                } else if (premiumSponsorshipToken) {
                  // Sponsorship was already accepted server-side as part of
                  // this login call — land straight on "Mon compte". Except
                  // when signing in with another account than the invited
                  // address: the back silently leaves the sponsorship alone
                  // there, so flag it through the reload for "Mon compte" to
                  // explain why the premium wasn't activated.
                  const mismatchedEmail =
                    premiumSponsorshipEmail &&
                    premiumSponsorshipEmail.toLowerCase() !==
                      loginData.email.toLowerCase()
                      ? premiumSponsorshipEmail
                      : null;
                  window.location.href = mismatchedEmail
                    ? `/account?sponsorshipEmailMismatch=${encodeURIComponent(
                        mismatchedEmail,
                      )}`
                    : "/account";
                } else {
                  window.location.href = await getLoggedUserHomeUrl();
                }
              },
              (err) => {
                if (err.response.status === 412) {
                  setShowUnvalidatedEmailPopup(true);
                }
              },
            );
        }}
        validationSchema={object({
          email: string().label(t("auth:login.EMAIL")).email().required(),
          password: string()
            .label(t("auth:login.PASSWORD"))
            .password()
            .required(),
        })}
      >
        <SxField name="email" />
        <SxField name="password" />
        <div className="--txt--right">
          <Link className="link --underlined" to="/lost-password">
            {t("auth:login.FORGOT_PASSWORD")}
          </Link>
        </div>
        <div className="lblock--l --txt--center">
          <SubmitButton type="submit">{t("auth:login.SIGN_IN")}</SubmitButton>
        </div>
      </SxForm>
      {showUnvalidatedEmailPopup && (
        <Dialog onClose={() => setShowUnvalidatedEmailPopup(false)}>
          <>
            <div className="popup_head">
              <div className="popup_title">
                {t("auth:login.NOT_VALIDATED_MAIL_TITLE")}
              </div>
            </div>
            <div className="popup_body">
              {t("auth:login.NOT_VALIDATED_MAIL_CONTENT")}
            </div>
          </>
        </Dialog>
      )}
    </>
  );
}

export default LoginForm;
